import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EluxIcon } from '@elxjs/ui'

@Component({
  selector: 'app-message-card',
  standalone: true,
  imports: [EluxIcon],
  templateUrl: './message-card.component.html',
  styleUrls: ['./message-card.component.scss'],
})
export class MessageCardComponent {
  @Input() message: string = ''
  @Input() type: 'info' | 'error' | 'success' = 'info'

  @Output() closed = new EventEmitter<void>()

  onCloseClick(): void {
    this.closed.emit()
  }
}
